import { fetchLinkedAdjustmentsByCode } from '../services/structuredAnalysisLinkedAdjustmentsService';
import { linkedAdjustmentsForDocumentUpdated } from '../actions/linkedAdjustments';

export const dispatchLinkedAdjustmentsForDocument = async (
  projectId,
  documentCode,
  dispatch
) => {
  const linkedAdjustments = await fetchLinkedAdjustmentsByCode(
    projectId,
    documentCode
  );

  dispatch(
    linkedAdjustmentsForDocumentUpdated(documentCode, linkedAdjustments)
  );
};
